import { useState, useEffect } from "react";
import { getMyaccountLastPurchases } from "../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
import { formatDate } from "../../../siteWidgets/siteWidgetUtils";
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces";
import { HyperLinkBuilder } from "../../../commonComponents/inline/hyperLink"

interface LastPurchaseProperties {
    contactUsPage: { url: string, target: LinkTargetProperties };
    userData: any;
}

const PaywallMyAccountLastPurchases = (props: LastPurchaseProperties) => {

    const [lastPurchases, setLastPurchases] = useState([]);
    const [generalError, setGeneralError] = useState('');

    const sourceDisplayMap = {
        'google': 'Google',
        'ios': 'iOS'
    };

    const fetchLastPurchases = async (url) => {
        try {
            const { data, status } = await axios.get(url);
            if (status === 200 && data && (data as any).data) {
                setLastPurchases((data as any).data as []);
            }
        } catch (error) {
            console.error(error);
            setGeneralError("משהו השתבש, נסו שוב מאוחר יותר");
        }
    };

    useEffect(() => {
        fetchLastPurchases(getMyaccountLastPurchases());
    }, [])

    if (generalError) {
        return <div className="PaywallMyAccountLastPurchases"><div className="general-error">{generalError}</div></div>
    }

    const getContactUsUrlWithParams = (formData) => {
        try {
            const contactPageUrl = props.contactUsPage.url || "/";
            const url = new URL(contactPageUrl);
            const params = url.searchParams;
            params.set('firstName', formData.firstName || '');
            params.set('email', formData.email || '');
            params.set('phone', formData.phoneNumber || '');
            params.set('subject', 'בקשה לביטול מינוי');
            params.set('message', `ביטול מינוי ללקוח ל: ${formData.email}
    חבילה - ${lastPurchases[0].packageName}\n`);
            return url.toString();
        } catch (e) {
            console.error('', e);
            return '';
        }
    };



    return (
        <div className="PaywallMyAccountLastPurchases">
            <div className="table">
                <div className="header">
                    <span className="header-type">סוג חבילה</span>
                    <span className="header-date">תאריך רכישה</span>
                </div>
                <div className="list">
                    {lastPurchases.map(({ packageName, purchaseDate, isActive, source}, index) => {

                        const isActiveLabel = isActive ? '(פעיל)' : '(לא פעיל)';
                        const isGoogleOrIos = source === 'google' || source === 'ios';
                        const displaySource = sourceDisplayMap[source] || source;
                  
                        return <div key={index} className="row">
                            <div className="type-container">
                                <div className="type">{packageName}</div>
                                <div className="active-label">{` ${isActiveLabel} `}</div>
                                {isActive && <HyperLinkBuilder linkTarget={props.contactUsPage.target} href={getContactUsUrlWithParams(props.userData)} className="cancel">ביטול מינוי</HyperLinkBuilder>}
                                {isGoogleOrIos && <div className="source">נרכש ב - {displaySource}</div>}
                            </div>
                            <div className="date">{formatDate(new Date(purchaseDate), 'DD/MM/YYYY')}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    );
};

export default PaywallMyAccountLastPurchases;